/**
 * @fileoverview gRPC-Web generated client stub for clientpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.clientpb = require('./file_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.clientpb.FileServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.clientpb.FileServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clientpb.ListFileRequest,
 *   !proto.clientpb.ListFileResponse>}
 */
const methodDescriptor_FileService_ListFile = new grpc.web.MethodDescriptor(
  '/clientpb.FileService/ListFile',
  grpc.web.MethodType.UNARY,
  proto.clientpb.ListFileRequest,
  proto.clientpb.ListFileResponse,
  /**
   * @param {!proto.clientpb.ListFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.ListFileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.clientpb.ListFileRequest,
 *   !proto.clientpb.ListFileResponse>}
 */
const methodInfo_FileService_ListFile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.clientpb.ListFileResponse,
  /**
   * @param {!proto.clientpb.ListFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.ListFileResponse.deserializeBinary
);


/**
 * @param {!proto.clientpb.ListFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.clientpb.ListFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clientpb.ListFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clientpb.FileServiceClient.prototype.listFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clientpb.FileService/ListFile',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFile,
      callback);
};


/**
 * @param {!proto.clientpb.ListFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clientpb.ListFileResponse>}
 *     Promise that resolves to the response
 */
proto.clientpb.FileServicePromiseClient.prototype.listFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clientpb.FileService/ListFile',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clientpb.DownloadFileRequest,
 *   !proto.clientpb.DownloadFileMetaDataResponse>}
 */
const methodDescriptor_FileService_DownloadFileMetaData = new grpc.web.MethodDescriptor(
  '/clientpb.FileService/DownloadFileMetaData',
  grpc.web.MethodType.UNARY,
  proto.clientpb.DownloadFileRequest,
  proto.clientpb.DownloadFileMetaDataResponse,
  /**
   * @param {!proto.clientpb.DownloadFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.DownloadFileMetaDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.clientpb.DownloadFileRequest,
 *   !proto.clientpb.DownloadFileMetaDataResponse>}
 */
const methodInfo_FileService_DownloadFileMetaData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.clientpb.DownloadFileMetaDataResponse,
  /**
   * @param {!proto.clientpb.DownloadFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.DownloadFileMetaDataResponse.deserializeBinary
);


/**
 * @param {!proto.clientpb.DownloadFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.clientpb.DownloadFileMetaDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clientpb.DownloadFileMetaDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clientpb.FileServiceClient.prototype.downloadFileMetaData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clientpb.FileService/DownloadFileMetaData',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadFileMetaData,
      callback);
};


/**
 * @param {!proto.clientpb.DownloadFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clientpb.DownloadFileMetaDataResponse>}
 *     Promise that resolves to the response
 */
proto.clientpb.FileServicePromiseClient.prototype.downloadFileMetaData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clientpb.FileService/DownloadFileMetaData',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadFileMetaData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clientpb.DownloadFileRequest,
 *   !proto.clientpb.DownloadFileChunkResponse>}
 */
const methodDescriptor_FileService_DownloadFileChunk = new grpc.web.MethodDescriptor(
  '/clientpb.FileService/DownloadFileChunk',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.clientpb.DownloadFileRequest,
  proto.clientpb.DownloadFileChunkResponse,
  /**
   * @param {!proto.clientpb.DownloadFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.DownloadFileChunkResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.clientpb.DownloadFileRequest,
 *   !proto.clientpb.DownloadFileChunkResponse>}
 */
const methodInfo_FileService_DownloadFileChunk = new grpc.web.AbstractClientBase.MethodInfo(
  proto.clientpb.DownloadFileChunkResponse,
  /**
   * @param {!proto.clientpb.DownloadFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.DownloadFileChunkResponse.deserializeBinary
);


/**
 * @param {!proto.clientpb.DownloadFileRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.clientpb.DownloadFileChunkResponse>}
 *     The XHR Node Readable Stream
 */
proto.clientpb.FileServiceClient.prototype.downloadFileChunk =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/clientpb.FileService/DownloadFileChunk',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadFileChunk);
};


/**
 * @param {!proto.clientpb.DownloadFileRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.clientpb.DownloadFileChunkResponse>}
 *     The XHR Node Readable Stream
 */
proto.clientpb.FileServicePromiseClient.prototype.downloadFileChunk =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/clientpb.FileService/DownloadFileChunk',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadFileChunk);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clientpb.ListInvoiceRequest,
 *   !proto.clientpb.ListInvoiceResponse>}
 */
const methodDescriptor_FileService_ListInvoice = new grpc.web.MethodDescriptor(
  '/clientpb.FileService/ListInvoice',
  grpc.web.MethodType.UNARY,
  proto.clientpb.ListInvoiceRequest,
  proto.clientpb.ListInvoiceResponse,
  /**
   * @param {!proto.clientpb.ListInvoiceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.ListInvoiceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.clientpb.ListInvoiceRequest,
 *   !proto.clientpb.ListInvoiceResponse>}
 */
const methodInfo_FileService_ListInvoice = new grpc.web.AbstractClientBase.MethodInfo(
  proto.clientpb.ListInvoiceResponse,
  /**
   * @param {!proto.clientpb.ListInvoiceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clientpb.ListInvoiceResponse.deserializeBinary
);


/**
 * @param {!proto.clientpb.ListInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.clientpb.ListInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clientpb.ListInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clientpb.FileServiceClient.prototype.listInvoice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clientpb.FileService/ListInvoice',
      request,
      metadata || {},
      methodDescriptor_FileService_ListInvoice,
      callback);
};


/**
 * @param {!proto.clientpb.ListInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clientpb.ListInvoiceResponse>}
 *     Promise that resolves to the response
 */
proto.clientpb.FileServicePromiseClient.prototype.listInvoice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clientpb.FileService/ListInvoice',
      request,
      metadata || {},
      methodDescriptor_FileService_ListInvoice);
};


module.exports = proto.clientpb;

